import { SmallAddIcon } from "@chakra-ui/icons";
import { Button, HStack, Link } from "@chakra-ui/react";
import { FormValues } from "features/entities/EntityCreatePage/EntityCreatePage";
import { SecurityClassBaseData } from "gen/model/securityClassBaseData";
import { SecurityTypeEnum } from "gen/model/securityTypeEnum";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  ContentBlock,
  ContentBlockBody,
  ContentBlockHeader,
  ContentBlockTitle,
} from "shared/components/content/ContentBlock";
import { FormFieldPrefix } from "shared/components/form/FormFieldPrefix";
import { FormFieldset } from "shared/components/form/FormFieldset";
import { FormSelect } from "shared/components/input/select/Select";
import { SelectOption } from "shared/components/input/select/SelectOption";
import { FormTextInput } from "shared/components/input/text/TextInput";

export const makeEmptyShareClass = (): SecurityClassBaseData => ({
  name: "",
  security_type: "" as SecurityTypeEnum,
});

const ShareClasses: React.FC = () => {
  const form = useFormContext<FormValues>();

  const { fields, append, remove } = useFieldArray({
    control: form.control,
    name: "security_class_base_data",
  });

  const { t } = useTranslation(["entity"]);

  return (
    <ContentBlock>
      <ContentBlockHeader>
        <ContentBlockTitle>Share classses</ContentBlockTitle>
      </ContentBlockHeader>
      <ContentBlockBody px={4} pb={4}>
        {fields.map((_, index) => (
          <ShareClassFormInput
            key={index}
            index={index}
            remove={() => remove(index)}
          />
        ))}
        <Button
          colorScheme="secondary"
          size="sm"
          iconSpacing="2px"
          leftIcon={<SmallAddIcon />}
          onClick={() => append(makeEmptyShareClass())}
        >
          {t("entity:create.share_classes.add_another")}
        </Button>
      </ContentBlockBody>
    </ContentBlock>
  );
};

export default ShareClasses;

const ShareClassFormInput: React.FC<{
  index: number;
  remove: () => void;
}> = ({ index, remove }) => {
  const { t } = useTranslation(["entity"]);
  return (
    <FormFieldPrefix prefix={`security_class_base_data.${index}`}>
      <FormFieldset border="1px dashed" borderColor="gray.400">
        <FormSelect
          name="security_type"
          title={t("entity:create.share_classes.type")}
        >
          {Object.values(SecurityTypeEnum).map((key) => (
            <SelectOption key={key} value={key}>
              {t(`enums:SecurityTypeEnum.${key}`)}
            </SelectOption>
          ))}
        </FormSelect>
        <FormTextInput
          name="name"
          title={t("entity:create.share_classes.name")}
        />
        <HStack justifyContent="flex-end">
          <Link size="sm" colorScheme="gray" onClick={() => remove()}>
            {t("entity:create.share_classes.remove")}
          </Link>
        </HStack>
      </FormFieldset>
    </FormFieldPrefix>
  );
};
